module.exports = __webpack_public_path__ + "static/media/celular.18fa90a4.svg";